import { ReduxStore } from 'store/types';

function editIsLoading(state: ReduxStore): boolean {
  return state.settings.edit.config.isLoading;
}

export default editIsLoading;
